<div class="card panel-flat-color secondary-panel valuation-panel">
    <div class="panel-flat-header pointer" (click)="expandOrCollapse()">
        <panel-chevron [showBody]="showBody"></panel-chevron>
        <h3>Valuation</h3>
    </div>
    @if (showBody) {
        <div class="card-body" style="padding-top: 0;height: 490px;">
            <tabset>
                <tab heading="Income Statements" (selectTab)="incomeStatementSelected()">
                    @if (onIncomeStatementLoading) {
                        <div class="text-center" style="margin-top: 50px;">
                            <ws-ace-loader [hasOverlay]="false" [marginTop]="0" [marginBottom]="0"></ws-ace-loader>
                        </div>
                    }
                    <div [hidden]="onIncomeStatementLoading"
                         class="ws-flex-container-horizontal ws-stretch ws-overflow-auto">
                        @if (showIncomeStatement) {
                            <income-statement-list [companyIdFilter]="companyId"
                                                   [parcelIdFilter]="parcelId"
                                                   [siteIdFilter]="siteId"
                                                   [isEmbededMode]="true"
                                                   [(onLoading)]="onIncomeStatementLoading"></income-statement-list>
                        }
                    </div>
                </tab>
                <tab heading="Rent Rolls" (selectTab)="rentRollSelected()">
                    @if (onRentRollLoading) {
                        <div class="text-center" style="margin-top: 50px;">
                            <ws-ace-loader [hasOverlay]="false" [marginTop]="0" [marginBottom]="0"></ws-ace-loader>
                        </div>
                    }
                    <div [hidden]="onRentRollLoading" class="ws-flex-container-horizontal ws-stretch ws-overflow-auto">
                        @if (showRentRoll) {
                            <rent-roll-list [companyIdFilter]="companyId"
                                            [parcelIdFilter]="parcelId"
                                            [siteIdFilter]="siteId"
                                            [isEmbededMode]="true"
                                            [(onLoading)]="onRentRollLoading"></rent-roll-list>
                        }
                    </div>
                </tab>
            </tabset>
        </div>
    }
</div>
